import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { QuestionRenderer } from '~/widgets/survey/components/QuestionRenderer';
import { useRootStore } from '~base/hooks/useRootStore';
import { SurveyFormField } from '~modules/surveys/forms/SurveyForm';
import { SurveyExtraQuestionModel } from '~modules/surveys/models/SurveyExtraQuestionModel';
import { SurveyQuestionModel } from '~modules/surveys/models/SurveyQuestionModel';
import { SurveyAnswerTypeIdEnum } from '~modules/surveys/types/SurveyAnswerTypeIdEnum';

interface IExtraQuestionProps {
  parentName: string;
  parentIndex: number;
  extraIndex: number;
  question: SurveyExtraQuestionModel;
}

export const ExtraQuestion: React.FC<IExtraQuestionProps> = observer((props) => {
  const { question, parentIndex, extraIndex } = props;

  const { surveyStore } = useRootStore();

  const { setValue, control } = useFormContext();

  const name = `${SurveyFormField.questions}[${parentIndex}].extraQuestions[${extraIndex}]`;
  const parentName = `${SurveyFormField.questions}[${parentIndex}]`;

  const parentQuestion: SurveyQuestionModel = useWatch({ name: parentName, control });

  let shouldShow = false;

  if (parentQuestion.answerTypeId === SurveyAnswerTypeIdEnum.CHECKBOX_GROUP) {
    parentQuestion.answers.forEach((answer) => {
      if (
        answer?.isChecked &&
        answer.happyIndex &&
        question.happyIndexMin &&
        question.happyIndexMax &&
        answer.happyIndex >= question.happyIndexMin &&
        answer.happyIndex <= question.happyIndexMax
      ) {
        shouldShow = true;
      }
    });
  } else {
    if (
      parentQuestion.happyIndex &&
      question.happyIndexMin &&
      question.happyIndexMax &&
      parentQuestion.happyIndex >= question.happyIndexMin &&
      parentQuestion.happyIndex <= question.happyIndexMax
    ) {
      shouldShow = true;
    }
  }

  // Очистка поля, если больше не отображается
  useEffect(() => {
    const defaultQuestion = surveyStore.survey?.questions[parentIndex].extraQuestions[extraIndex];

    if (!shouldShow && defaultQuestion) {
      const preparedQuestion = surveyStore.prepareDefaultExtraQuestion(defaultQuestion);

      setValue(name, preparedQuestion);
    }
  }, [shouldShow, name, setValue, parentIndex, extraIndex]);

  if (!shouldShow) {
    return null;
  }

  return (
    <Box mt={2}>
      <Typography variant="subtitle2" fontSize={16} mb={1}>
        {`${parentIndex + 1}.${extraIndex + 1}. ${question.descr ?? ''}`}
      </Typography>

      <QuestionRenderer question={question} name={name} />
    </Box>
  );
});
